import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import HistoryIcon from '@mui/icons-material/History';
import { Box, Menu, Avatar, Button, IconButton, Typography } from '@mui/material';

import { CircleLoading } from 'shared';
import { ACTIVITY_LABELS } from './utils/history.constants';
import { historyDropDownStyles } from './styles/HistoryDropDown.style';
import { useHistoryService } from '../../store/services/history.service';

const pageSize = 3;

const HistoryDropDown = ({ onSeeAllClick }) => {
    const companyId = useSelector((state) => state?.company?.data?.id);

    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activities, setActivities] = useState([]);

    const classes = historyDropDownStyles();
    const { getHistoryActions } = useHistoryService();

    const handleClick = async (event) => {
        setAnchorEl(event.currentTarget);
        if (companyId) {
            setLoading(true);
            try {
                const data = await getHistoryActions({ companyId, page: 1, pageSize });
                setActivities(data?.results || []);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <HistoryIcon sx={classes.historyIcon} />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{ sx: classes.menuPaper }}
            >
                <Box sx={classes.menuBox}>
                    <Typography variant="h6" sx={classes.notificationsTitle}>
                        History
                    </Typography>

                    <Box sx={classes.activitiesColumn}>
                        {loading ? (
                            <Box sx={classes.loaderBox}>
                                <CircleLoading size={24} />
                            </Box>
                        ) : activities.length === 0 ? (
                            <Typography>No recent activity.</Typography>
                        ) : (
                            activities.map((item, index) => (
                                <Box key={item.id || index} sx={classes.activityItem}>
                                    <Avatar sx={classes.avatar}>
                                        <HistoryIcon sx={{ color: 'white', fontSize: '20px' }} />
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="body1" sx={classes.activityTitle}>
                                            {ACTIVITY_LABELS[item.action] || item.action}
                                        </Typography>
                                        <Typography variant="body2" sx={classes.activityDesc}>
                                            {item.first_name} {item.last_name}
                                            {item.inventory_file_name && (
                                                <> — {item.inventory_file_name}</>
                                            )}
                                            {item.transactions_file_name && (
                                                <> — {item.transactions_file_name}</>
                                            )}
                                            {item.remittance_file_name && (
                                                <> — {item.remittance_file_name}</>
                                            )}
                                            {item.invoice_file_name && (
                                                <> — {item.invoice_file_name}</>
                                            )}
                                            {item.aggregated_count > 0 && (
                                                <> (x{item.aggregated_count})</>
                                            )}
                                        </Typography>
                                        <Typography variant="caption" sx={classes.activityTime}>
                                            {new Date(item.created_at).toLocaleString()}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))
                        )}
                    </Box>

                    <Button
                        fullWidth
                        variant="text"
                        sx={classes.seeAllButton}
                        onClick={() => {
                            handleClose();
                            onSeeAllClick && onSeeAllClick();
                        }}
                    >
                        <Typography variant="body2">See All History</Typography>
                    </Button>
                </Box>
            </Menu>
        </>
    );
};

export default HistoryDropDown;
